/**
 * Centralised, typed access to build-time environment. Every browser-exposed
 * value must be prefixed with VITE_. No secrets belong here (spec §36).
 */
function readString(value: string | undefined, fallback: string): string {
  const trimmed = value?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : fallback;
}

export const env = {
  /** Axios base URL. Relative by default so the dev proxy keeps cookies first-party. */
  apiBaseUrl: readString(import.meta.env.VITE_API_BASE_URL, '/api/v1'),
  /** Socket.IO origin. Empty string = same origin (dev proxy / same-domain prod). */
  socketUrl: readString(import.meta.env.VITE_SOCKET_URL, ''),
  appName: readString(import.meta.env.VITE_APP_NAME, 'Agency Admin'),
  appEnv: readString(import.meta.env.VITE_APP_ENV, import.meta.env.MODE),
  isProduction: import.meta.env.PROD,
  isDevelopment: import.meta.env.DEV,
} as const;

export type Env = typeof env;
